<template>
	<span
		class="cart-count"
	>
		{{ cartCount >= 0 ? cartCount : '...' }}
	</span>
</template>

<script>
	import axios from 'axios';
	export default {
		data: function () {
			return {
				gotResponse: false,
				cartCount: 0
			}
		},
		mounted() {
			axios.get(`/api/v1/cart`)
				.then((response) => {
					this.gotResponse = true;
					var count = 0;
					if (response.data) {
						for (var key in response.data.data.items) {
							count += response.data.data.items[key].qty;
						}
					}
					console.log(count);
					this.cartCount = count;
				});
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/CartCount.vue